import { useEffect, useState } from "react";
import apiService from "../services/api";
import eventsLocal from "../data/events";

/**
 * Hook to fetch a single event by slug
 * Merges API data with local fallback data
 */
export function useEventDetail(slug) {
  const [event, setEvent] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let isMounted = true;

    async function fetchEvent() {
      try {
        setLoading(true);
        setError(null);

        const json = await apiService.getEventBySlug(slug);
        const apiEvent = json.data || json;

        const localEvent = eventsLocal.find(
          (e) => e.event_public_id === slug
        );

        console.log("Local Event:", localEvent);

        const mergedEvent = {
          ...localEvent,
          ...apiEvent,
        };

        if (isMounted) {
          setEvent(mergedEvent);
        }
      } catch (err) {
        console.warn(
          "API offline or error → using local data:",
          err.message
        );

        const localEvent = eventsLocal.find(
          (e) => e.event_public_id === slug
        );

        if (isMounted) {
          setError(err.message);
          setEvent(localEvent || null);
        }
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
    }

    if (slug) {
      fetchEvent();
    }

    return () => {
      isMounted = false;
    };
  }, [slug]);

  return { event, loading, error };
}
